import { hotRanking } from '@/mocks/animeData';

export default function HotRanking() {
  return (
    <section
      id="ranking"
      className="scroll-mt-20 bg-background-100 px-4 py-12 md:px-6 md:py-16"
    >
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              热门榜单
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              综合阅读热度与读者口碑，每日自动刷新的人气风向标
            </p>
          </div>
          <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
            <i className="ri-fire-fill"></i>
            实时热度榜
          </span>
        </div>

        <div className="grid grid-cols-1 gap-3 md:gap-4 lg:grid-cols-2">
          {hotRanking.map((comic, idx) => (
            <article
              key={comic.id}
              className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4"
              data-product-shop
            >
              <div className="relative w-full max-w-[96px] shrink-0 sm:max-w-[120px]">
                <img
                  src={comic.image}
                  alt={`${comic.title} 漫画封面`}
                  title={`热门榜第${comic.rank}名 ${comic.title}`}
                  className="aspect-[3/4] w-full rounded-md object-cover object-top"
                />
                <span
                  className={`absolute -left-2 -top-2 flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold text-background-50 ${
                    idx < 3 ? 'bg-primary-500' : 'bg-secondary-600'
                  }`}
                >
                  {comic.rank}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="truncate text-base font-bold text-foreground-950 group-hover:text-primary-700">
                    {comic.title}
                  </h3>
                  <span className="inline-flex shrink-0 items-center gap-1 text-sm font-bold text-secondary-500">
                    <i className="ri-star-fill"></i>
                    {comic.score}
                  </span>
                </div>
                <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-600">
                  {comic.desc}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
                    {comic.genre}
                  </span>
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-600"
                    >
                      {tag}
                    </span>
                  ))}
                  <span className="ml-auto text-xs text-foreground-400">
                    更新至 {comic.chapter}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}